function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.36 12.11h.834l4.48 4.49a1.113 1.113 0 01-1.573 1.575l-4.49-4.482v-.833l-.286-.296a6.83 6.83 0 01-4.464 1.657 6.86 6.86 0 116.86-6.86 6.83 6.83 0 01-1.657 4.464l.296.285zM2.11 7.36a4.743 4.743 0 004.75 4.75 4.743 4.743 0 004.75-4.75 4.743 4.743 0 00-4.75-4.75 4.743 4.743 0 00-4.75 4.75z",
  fill: "#057CCC"
})));